import { Stack } from '@mui/material';
import Chip from '/@/components/bayer/chip';
import type { UserNode } from '/@/hooks/nodes';

const SquadFilterPills = ({
    squads,
    selectedSquadId,
    onSelectSquad,
}: {
    squads: UserNode[];
    selectedSquadId: number | null;
    onSelectSquad: (squadId: number) => void;
}) => (
    <Stack direction='row' flexWrap='wrap' spacing={1} useFlexGap sx={{ mb: 3 }}>
        {squads.map((squad) => (
            <Chip
                key={squad.id}
                selected={selectedSquadId === squad.id}
                onClick={() => onSelectSquad(squad.id)}
                label={squad.name}
            />
        ))}
    </Stack>
);

export default SquadFilterPills;
